import React, { useState } from "react";
import Sparkles from "react-sparkle";
import "./PlusIcon.scss";

function PlusIcon(props) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={"plus-icon" + (props.big ? " plus-icon-bigger" : "")}
      style={{ ...props.style }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => {
        window.location.href = "/upgrade";
      }}
    >
      {isHovered && (
        <Sparkles
          flicker={false}
          count={20}
          fadeOutSpeed={5}
          color={"#8358E8"}
        />
      )}
      <p>PLUS</p>
    </div>
  );
}

export default PlusIcon;
